<template>
  <!-- 로그인 팝업 -->
  <div class="popup_mask" @click="loginClosePopupMask">
    <div class="log_popup">
      <img src="@/assets_mobile/img/winner_mobile/main/login_bg.png" alt="" />
      <div class="popup_inner" @keyup.enter="onSubmit">
        <p><input type="text" v-model="model.memId" name="mb_id" placeholder="Your ID" @keyup.enter="onSubmit" /></p>
        <p><input type="password" name="mb_password" v-model="model.memPass" placeholder="********" @keyup.enter="onSubmit" /></p>
          <p class="save_id tx"><input type="checkbox" id="save_id" v-model="saveId"><label for="save_id">{{ $t('front.login.saveID') }}</label></p>
          <button type="submit" id="btn-login" @click.prevent="onSubmit">Login</button>
        </div>
    </div>
  </div>
</template>

<script>
import { memberMixin } from '@/mixin/member';
export default {
  name: 'Signin',
  mixins: [memberMixin]
}
</script>
<style>
.save_id {
  padding: 5px 0;
}
</style>
